module.exports = __webpack_public_path__ + "img/GAME_GUKHWAPPANG1.99ac7b06.jpg";